import { DataGrid, formatDate } from '@ijoin/components';
import {
  AdminAdvisoryOrgLicenseRes,
  useGetAdminAdvisoryOrganizationLicenses
} from '@ijoin/hooks';
import { Stack, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { createFileRoute, Link } from '@tanstack/react-router';

const columns: GridColDef<AdminAdvisoryOrgLicenseRes>[] = [
  {
    field: 'description',
    flex: 2,
    headerName: 'Type',
    valueGetter: (_value, row) => row.RKOLicenseTypes?.description
  },
  {
    field: 'createdAt',
    flex: 1,
    headerName: 'Created',
    valueFormatter: value =>
      value ? formatDate(value, { format: 'MM/DD/YYYY h:mm A' }) : ''
  }
];

const LicensingTab = () => {
  const { advisoryOrganizationId } = Route.useParams();

  const licenses = useGetAdminAdvisoryOrganizationLicenses(
    advisoryOrganizationId
  );
  const billingRko = licenses.data?.billingRecordKeepingOrganization;

  return (
    <Stack spacing={2} sx={{ flex: 1, minHeight: 0 }}>
      <Stack spacing={1} sx={{ flex: 1, minHeight: 0 }}>
        {billingRko ? (
          <Typography variant='body2'>
            Licenses are inherited from billing record keeper{' '}
            <Link
              params={{
                recordKeepingOrganizationId:
                  billingRko.recordKeepingOrganizationId
              }}
              to='/recordkeepers/$recordKeepingOrganizationId'>
              {billingRko.name}
            </Link>
            . Add or remove them there.
          </Typography>
        ) : (
          <Typography color='text.secondary' variant='body2'>
            No billing record keeper set. Set one on the organization to inherit
            its licenses.
          </Typography>
        )}
        <DataGrid
          autoHeight={false}
          columns={columns}
          disableColumnMenu
          disableRowSelectionOnClick
          getRowId={row => row.rkoLicenseId}
          loading={licenses.isFetching}
          rows={licenses.data?.data ?? []}
          showColumnMenu
          slotProps={{
            root: {
              'data-component': 'dataGrid',
              'data-testid': 'inheritedLicenses'
            }
          }}
          sx={{ flex: 1, minHeight: 0 }}
        />
      </Stack>
    </Stack>
  );
};

export const Route = createFileRoute(
  '/organizations/$advisoryOrganizationId/licensing'
)({
  component: LicensingTab
});
